export function fixFileName(name : string | undefined){
  if(name){
    return name.replace(/[/\\?%+*:|"<>]/g, '');
  }else{
    return ""
  }
}